import { gql } from '@apollo/client';

import { TestFragment } from '../fragments';

export const StartTestMutation = gql`
    mutation StartTest($subjectId: ID, $courseId: ID!) {
        startOLTest(subjectId: $subjectId, courseId: $courseId) {
            ...Test
        }
    }
    ${TestFragment}
`;
